export default __webpack_public_path__ + "79d10ce58a7f195ca82c577cc03fed7f.svg";